import {
    IAdvertisementPlacement,
    IAdvertisementPayload,
    AdvertisementArea,
    AdvertisementType,
} from '../../SDK/Advertisement';
import { FBTrackingEvent } from '../FBTrackingEvent';
import Game from '../../../Game';
import { track, sendEvent } from '../Track';
import { TransactionType } from '../DataSet/Transaction';
import { AdTrackingEventName } from '../TrackingEvent';
import { AdType } from '../DataSet/Ad';
import { IGameState } from '../../../State/Game/IGameState';

export function trackRequestAdvertisement(
    state: IGameState,
    placement: IAdvertisementPlacement,
    payload?: IAdvertisementPayload
) {
    try {
        track('placementID', placement.id);
        track('adType', AdType.REWARDED);
        if (placement.type === AdvertisementType.INTERSTITIAL) {
            track('adType', AdType.INTERSTITIAL);
            Game.sdk.gameTracking(FBTrackingEvent.Design_InterstitialAdRequested);
        } else if (placement.type === AdvertisementType.REWARDED) {
            Game.sdk.gameTracking(FBTrackingEvent.Design_RewardedAdRequested);
        }

        if (payload) {
            track('adAdvertisementArea', payload.g_gameArea);
            track('adGameArea', payload.g_gameArea);
            if (payload.reward) {
                track('adRewardType', payload.reward.type);
                track('transactionType', TransactionType.AD);
            }
        }

        sendEvent(AdTrackingEventName.adRequest, state);
    } catch (e) {
        console.error('Failed to track', e);
    }
}
export function trackDisplayedAdvertisement(
    state: IGameState,
    placement: IAdvertisementPlacement,
    payload?: IAdvertisementPayload
) {
    try {
        switch (payload.g_gameArea) {
            case AdvertisementArea.NO_COINS_MENU:
                Game.sdk.gameTracking(FBTrackingEvent.VideoAdWatchGetCoins_NotEnoughCoins);
                break;
            case AdvertisementArea.FREE_COINS:
                Game.sdk.gameTracking(FBTrackingEvent.VideoAdWatchGetCoins_CoinBar);
                break;
            case AdvertisementArea.WATCH_TO_PLAY:
                Game.sdk.gameTracking(FBTrackingEvent.VideoAdWatchToPlay);
                break;
            default:
                break;
        }

        if (placement.type === AdvertisementType.INTERSTITIAL) {
            Game.sdk.gameTracking(FBTrackingEvent.Design_InterstitialAdDisplayed);
        } else if (placement.type === AdvertisementType.REWARDED) {
            Game.sdk.gameTracking(FBTrackingEvent.Design_RewardedAdDisplayed);
        }
        sendEvent(AdTrackingEventName.adShow, state);
    } catch (e) {
        console.error('Failed to track', e);
    }
}
